import styled from 'styled-components';

export const SectionStack = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 16px;
    overflow-anchor: none;
`;
